import { createSelector } from 'reselect'

import { getApp, getProfile, getUser } from '@/common/selectors'
import { PaymentMethod, PAYS_TO_TYPES, ProfileType, UserProfileStatuses } from '@/store/user/types'

export default createSelector([getUser, getApp, getProfile], (user, app, profile) => ({
  user,
  app,
  shouldShowBusinessModal:
    !(profile.pays_to === PAYS_TO_TYPES.AZ_ADHAND && profile.payment_method === PaymentMethod.CARD) &&
    profile.paying_customer &&
    profile.profile_type === ProfileType.INDIVIDUAL &&
    !profile.country_is_ready &&
    !profile.business_info &&
    !profile.legal_status?.includes(UserProfileStatuses.REJECTED) &&
    !profile.policy_status?.includes(UserProfileStatuses.REJECTED),
}))
